import groupBy from 'lodash/groupBy'

import { type StoreState, useStore } from '~/store/store'
import { selectLocation, selectPractitioner, selectSpeciality } from '~/storm'

import { saveStatuses } from './saveStatuses'
import { DatePractitionerCell } from './utils'

type DatePractitionerLocationCell = DatePractitionerCell & { locationId: number }

type AutoAssignStatuses = 'SURGERY' | 'DAY_SURGERY'

export const selectAutoAssignStatus = (state: StoreState, { locationId, practitionerId }: DatePractitionerLocationCell): AutoAssignStatuses | undefined => {
    const location = selectLocation(state, { where: { id: locationId } })
    const practitioner = selectPractitioner(state, { where: { id: practitionerId }, include: { departments: true } })

    if (!location || !practitioner) return

    const speciality = selectSpeciality(state, { where: { uuid: practitioner.speciality_uuid } })
    // HARDCODED VALUE - but ØNH do not distinguish between SURGERY and DAY_SURGERY
    if (speciality?.name === 'Øre-nese-halssykdommer') {
        return 'SURGERY'
    }
    return location.default_care_level === 'outpatient' ? 'DAY_SURGERY' : 'SURGERY'
}

export const autoAssignStatuses = async (cells: DatePractitionerLocationCell[]) => {
    const cellsWithStatus = cells.flatMap(cell => {
        const status = selectAutoAssignStatus(useStore.getState(), cell)
        return status ? [{ cell, status }] : []
    })

    const groupedByStatus = groupBy(cellsWithStatus, p => p.status)

    const promises = Object.entries(groupedByStatus).map(([status, groupedCells]) =>
        saveStatuses(
            status,
            groupedCells.map(p => p.cell)
        )
    )

    await Promise.all(promises)
}
